export const ORDERED_LIST = "ordered";
export const BULLET_LIST = "bullet";
